import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles({
  baseSkeleton: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  longBase: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100% !important",
    },
  },
  firstPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
    },
  },
  secondPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
    },
  },
  secondRow: {
    marginLeft: "68px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: "0",
    },
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  longSk: {
    paddingBottom: "8px",
    marginBottom: "20px",
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100% !important",
    },
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px",
  },
});

export default styles;
